export const fr: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Tableau de Bord',
  'nav.focus': 'Focus Quotidien & Feuille de Route',
  'nav.ai_assistant': 'Moteur Opérationnel Automatisé',
  'nav.calendar': 'Google Calendar',
  'nav.book': 'Page Publique de Réservation',
  'nav.bookings': 'Réservations & Revenus',
  'nav.invoices': 'Factures',
  'nav.expenses': 'Dépenses',
  'nav.settings': 'QG Entreprise & Fiscalité',
  'nav.billing': 'Abonnements & Forfaits',
  'nav.j_lens': 'Coffre-fort J-Lens',
  'nav.concept': 'Concept & Philosophie',
  'nav.what_is': 'Qu’est-ce qu’AzuraOS ?',
  'nav.export': 'Exporter & Sauvegarder',
  'nav.menu': 'Menu',
  'nav.welcome': 'Bienvenue & Hub BYOK',
  'nav.app_stack_modules': 'Modules de l’Application',
  'nav.core_engines': '8 Moteurs Principaux',
  'nav.manifesto': 'Système & Manifeste des Fondateurs',
  'nav.workspace_actions': 'Actions de l’Espace',
  'nav.export_records': 'Exporter les Données',
  'nav.load_demo': 'Charger Données Démo',
  'nav.partnerships': 'Partenariats & Soutien',
  'nav.request_partnership': 'Demander Accès Partenaire',
  'nav.partner_subtext': 'Intégrations bancaires, cohortes et parrainages',
  'nav.interface_language': 'Langue de l’Interface',
  'nav.legal_trust': 'Légal & Conformité',
  'nav.security': 'Sécurité',
  'nav.faqs': 'FAQ',
  'nav.terms': 'Conditions',
  'nav.privacy': 'Confidentialité',
  'nav.refund': 'Politique de Remboursement',
  'nav.contact': 'Contact',
  'nav.report_bug': 'Signaler un Bogue',
  'nav.invite_founder': '+ Inviter un Fondateur',
  'nav.privacy_active': 'Mode Confidentialité : ACTIF',
  'nav.privacy_off': 'Mode Confidentialité : DÉSACTIVÉ',
  'nav.masked': 'Masqué',
  'nav.visible': 'Visible',
  'nav.live_margin': 'MARGE OPÉRATIONNELLE EN DIRECT',
  'nav.target_safe_zone': 'Cible Zone Sécurisée :',
  'nav.close_menu': 'Fermer le Menu',
  'nav.founder_access': 'Connexion / Accès Fondateur',
  'nav.private_vault': 'Coffre Privé Connecté',
  'nav.master_access': 'Accès Fondateur Maître',
  'nav.lifetime': 'À Vie',
  'nav.pro_active': 'Souverain Pro Actif',
  'nav.trial_days': 'Essai 7 Jours : {days} jours restants',
  'nav.trial_expired': 'Essai Expiré',
  'nav.manage': 'Gérer →',
  'nav.upgrade': 'Mettre à Niveau →',
  'nav.unlock_pro': 'Débloquer Pro →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Bonjour',
  'dash.greeting_afternoon': 'Bon après-midi',
  'dash.greeting_evening': 'Bonsoir',
  'dash.value_prop': 'Contrôle multi-flux au même endroit : saisissez 1 revenu et 1 dépense pour voir votre marge nette s’ajuster en temps réel.',
  'dash.manage_streams': 'Gérer les Flux de Revenus',
  'dash.close_streams': 'Fermer les Flux',
  'dash.income': 'Revenus',
  'dash.collected': 'Encaissé',
  'dash.unpaid': 'En Attente',
  'dash.expenses': 'Dépenses',
  'dash.across_records': 'Sur l’ensemble des données',
  'dash.net_profit': 'Bénéfice Net',
  'dash.daily_focus_title': 'Plan d’Action Quotidien & Revenus',
  'dash.daily_focus_sub': 'Tâches fondatrices prioritaires pour maximiser les profits',
  'dash.open_focus': 'Ouvrir le Plan d’Action',
  'dash.stream_profitability': 'Rentabilité par Flux',
  'dash.stream_sub': '1 offre ou flux multiples • Suivi de marge en direct',
  'dash.quick_actions': 'Actions Rapides',
  'dash.add_booking': 'Ajouter Réservation',
  'dash.add_booking_desc': 'Enregistrer un nouveau revenu client',
  'dash.add_expense': 'Ajouter Dépense',
  'dash.add_expense_desc': 'Enregistrer les coûts d’exploitation',
  'dash.add_insight': 'Ajouter un Insight',
  'dash.add_insight_desc': 'Créer une règle J-Lens',
  'dash.quick_add_title': 'Ajout Rapide',
  'dash.quick_revenue': '+ REVENU RAPIDE (RÉSERVATION)',
  'dash.quick_expense': '+ DÉPENSE RAPIDE (JOURNAL)',
  'dash.recent_activity': 'Activité Récente',
  'dash.no_activity': 'Aucune activité récente. Utilisez les actions rapides ci-dessus.',
  'dash.spotlight_insight': 'Insight Vedette J-Lens',
  'dash.access_vault': 'Accéder au Coffre →',
  'dash.sandbox_active': 'Bac à Sable Actif',
  'dash.load_demo_data': 'Charger Données Démo',
  'dash.clear_sandbox': 'Vider le Bac à Sable',
  'dash.clear_confirm': 'Effacer les données ?',
  'dash.yes_clear': 'Oui, effacer',
  'dash.cancel': 'Annuler',

  // Bookings View
  'bookings.title': '📅 Réservations & Flux',
  'bookings.subtitle': 'Canaux de revenus clients souverains',
  'bookings.public_page': 'Page Publique de Réservation',
  'bookings.import_csv': 'Importer CSV',
  'bookings.add_button': 'Ajouter Réservation',
  'bookings.client_link_title': 'Lien d’Auto-Planification Client',
  'bookings.client_link_desc': 'Partagez des liens de réservation personnalisés synchronisés avec Google Calendar.',
  'bookings.link_active': 'Actif',
  'bookings.generate_custom_link': '⚡ Générer Lien Personnalisé',
  'bookings.hide_custom_link': 'Masquer le Lien',
  'bookings.copy_standard_link': 'Copier Lien Standard',
  'bookings.copied_link': 'Lien copié !',
  'bookings.preview': 'Aperçu',
  'bookings.search_placeholder': 'Rechercher par client ou service...',
  'bookings.filter_all': 'Tous les Flux',
  'bookings.table_client': 'Nom du Client',
  'bookings.table_stream': 'Flux / Service',
  'bookings.table_date': 'Date',
  'bookings.table_amount': 'Montant',
  'bookings.table_status': 'Statut',
  'bookings.table_actions': 'Actions',
  'bookings.mark_paid': 'Marquer Payé',
  'bookings.mark_unpaid': 'Marquer Non Payé',
  'bookings.delete': 'Supprimer',
  'bookings.no_records': 'Aucune réservation trouvée. Utilisez "Ajouter Réservation" ci-dessus.',

  // Invoices View
  'invoices.title': '📄 Factures & Créances Clients',
  'invoices.subtitle': 'Facturation professionnelle et rapprochement des paiements',
  'invoices.create_invoice': 'Créer une Facture',
  'invoices.tab_all': 'Toutes les Factures',
  'invoices.tab_paid': 'Factures Payées',
  'invoices.tab_outstanding': 'En Attente / En Cours',
  'invoices.tab_overdue': 'En Retard',
  'invoices.table_number': 'N° Facture',
  'invoices.table_client': 'Client',
  'invoices.table_issue_date': 'Date d’Émission',
  'invoices.table_due_date': 'Date d’Échéance',
  'invoices.table_total': 'Montant Total',
  'invoices.table_status': 'Statut',
  'invoices.download_pdf': 'Télécharger PDF',
  'invoices.mark_as_paid': 'Marquer Payé',
  'invoices.no_records': 'Aucune facture générée. Créez-en une pour suivre vos créances.',

  // Expenses View
  'expenses.title': '💳 Dépenses & Journal d’Exploitation',
  'expenses.subtitle': 'Suivi des sorties et optimisation des déductions fiscales',
  'expenses.log_expense': 'Enregistrer Dépense',
  'expenses.import_csv': 'Importer CSV',
  'expenses.total_outflow': 'Dépenses Totales',
  'expenses.tax_deductible': 'Déductible Fiscalement',
  'expenses.search_placeholder': 'Rechercher par fournisseur ou description...',
  'expenses.filter_all': 'Toutes Catégories',
  'expenses.table_category': 'Catégorie',
  'expenses.table_description': 'Description / Fournisseur',
  'expenses.table_date': 'Date',
  'expenses.table_claimable': 'Déductible',
  'expenses.table_amount': 'Montant',
  'expenses.table_actions': 'Actions',
  'expenses.claimable_yes': 'Oui (Déductible)',
  'expenses.claimable_no': 'Non (Personnel / Non déductible)',
  'expenses.no_records': 'Aucune dépense enregistrée. Ajoutez vos coûts pour calculer les marges réelles.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Focus Quotidien & Plan de Croissance',
  'focus.subtitle': 'Actions prioritaires génératrices de revenus et de traction',
  'focus.add_task': 'Ajouter Tâche de Revenus',
  'focus.active_tasks': 'Tâches Prioritaires Actives',
  'focus.completed_tasks': 'Tâches Terminées',
  'focus.high_leverage': 'Priorité Élevée',
  'focus.mark_done': 'Terminer',
  'focus.delete_task': 'Supprimer',
  'focus.no_tasks': 'Tout est à jour ! Ajoutez une tâche stratégique pour maintenir l’élan.',

  // Automated Operational Engine
  'ai.title': '⚡ Moteur Opérationnel Automatisé',
  'ai.subtitle': 'Calculs chiffrés côté client et intelligence opérationnelle souveraine (Zéro Rétention de Données)',
  'ai.ask_placeholder': 'Interrogez votre moteur sur la trésorerie, les marges ou la stratégie de tarification...',
  'ai.send': 'Analyser',
  'ai.thinking': 'Le moteur opérationnel traite vos calculs financiers...',
  'ai.prompt_margin': 'Comment puis-je augmenter ma marge nette à 60 % ?',
  'ai.prompt_tax': 'Quelles dépenses déduire pour optimiser ma réserve fiscale ?',
  'ai.prompt_pricing': 'Comment structurer mes forfaits de consulting mensuels ?',
  'ai.clear_chat': 'Effacer l’Historique',

  // Business & Tax HQ
  'hq.title': '🏢 QG Entreprise & Fiscalité',
  'hq.subtitle': 'Profil, devise, règles fiscales, préréglages régionaux et audits comptables',
  'hq.tab_profile': 'Profil & Identité',
  'hq.tab_currency_tax': 'Devise & Règles Fiscales',
  'hq.tab_accountant_view': 'Vue Expert-Comptable & Audit CPA',
  'hq.tab_exports': 'Exports & Sauvegardes',
  'hq.tab_security': 'Sécurité & Confidentialité',
  'hq.jurisdiction_preset_title': 'Préréglage Régional de Juridiction',
  'hq.jurisdiction_preset_desc': 'Sélectionnez votre pays d’activité pour configurer automatiquement la devise locale, les taux de TVA et l’administration fiscale.',
  'hq.accountant_view_title': 'Vue Expert-Comptable & Audit CPA',
  'hq.accountant_view_desc': 'Dossier récapitulatif de pré-comptabilité prêt pour les experts-comptables ou les banques.',
  'hq.export_pdf_audit': 'Rapport d’Audit Imprimable en PDF',
  'hq.export_csv_audit': 'Exporter CSV pour Audit',
  'hq.currency_symbol': 'Symbole de Devise',
  'hq.currency_code': 'Code de Devise',
  'hq.vat_rate': 'Taux de TVA (%)',
  'hq.tax_authority': 'Nom de l’Autorité Fiscale',
  'hq.save_settings': 'Enregistrer les Paramètres',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Revenu Brut',
  'metric.total_expenses': 'Dépenses Totales',
  'metric.net_profit': 'Résultat Opérationnel Net',
  'metric.profit_margin': 'Marge Bénéficiaire Nette',
  'metric.active_bookings': 'Réservations Actives',
  'metric.paid_invoices': 'Factures Payées',
  'metric.unpaid_invoices': 'Factures en Attente',
  'metric.tax_buffer': 'Réserve Fiscale Estimée',
  'metric.currency': 'Devise d’Exploitation',
  'metric.tax_rate': 'Taux de TVA / Taxe',

  // Actions & Common Buttons
  'btn.save': 'Enregistrer',
  'btn.cancel': 'Annuler',
  'btn.download': 'Télécharger',
  'btn.export_pdf': 'Télécharger Rapport en PDF',
  'btn.export_csv': 'Exporter en CSV',
  'btn.cpa_pack': 'Exporter Pack Comptable',
  'btn.new_booking': 'Enregistrer Réservation',
  'btn.new_expense': 'Enregistrer Dépense',
  'btn.add_task': 'Ajouter Tâche',
  'btn.sync_calendar': 'Synchroniser Google Calendar',
  'btn.privacy_mode': 'Mode Confidentialité',
  'btn.manage_subscription': 'Gérer l’Abonnement',
  'btn.sign_in': 'Connexion / Accès',
  'btn.sign_out': 'Déconnexion',
  'btn.delete': 'Supprimer',
  'btn.edit': 'Modifier',
  'btn.close': 'Fermer',

  // Statuses
  'status.paid': 'Payé',
  'status.unpaid': 'En Attente',
  'status.overdue': 'En Retard',
  'status.safe': 'Marge Saine',
  'status.warning': 'Alerte Marge',
  'status.trial_active': 'Essai Gratuit Actif',
  'status.pro_active': 'Souverain Pro',
};
